// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=ecc667e7-e6a3-41f8-878c-494f5f474d4b";
};